import { MarkerClusterer } from '@googlemaps/markerclusterer';
import '../plugins/MicroTemplating';

function kebabCase(str) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
}

export default async function initGoogleMap() {
  if (!(window.google && window.google.maps) || window.GoogleMapInitialized) return;

  const { Map, InfoWindow } = await google.maps.importLibrary('maps');
  const { Geocoder } = await google.maps.importLibrary('geocoding');
  const { AdvancedMarkerElement } = await google.maps.importLibrary(
    'marker',
  );
  const { LatLng } = await google.maps.importLibrary('core');

  window.GoogleMapInitialized = true;
  const suitecaseSvgString =
    '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="51.5" viewBox="0 0 34 51.5"><defs><radialGradient id="a" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".102"/><stop offset="1" stop-opacity="0"/></radialGradient><radialGradient id="b" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".2"/><stop offset=".483" stop-opacity=".039"/><stop offset="1" stop-opacity="0"/></radialGradient></defs><g transform="translate(-654 -1829.5)"><ellipse cx="17" cy="7" rx="17" ry="7" transform="translate(654 1867)" fill="url(#a)"/><ellipse cx="8" cy="3" rx="8" ry="3" transform="translate(663 1870.5)" fill="url(#b)"/></g><path class="marker" d="M33.5 16.5c0 7.511-10.055 20.883-14.463 26.4a2.6 2.6 0 0 1-4.073 0C10.555 37.383.5 24.011.5 16.5a16.5 16.5 0 0 1 33 0Z" fill="#fff"/><path class="icon" d="M14.563 11.5H14v2.25h-3v9h12v-9h-3V11.5h-5.437Zm4.313 2.25h-3.75v-1.125h3.75Z" fill="#1a1a1a"/></svg>';
  const buildingSvgString =
    '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="51.5" viewBox="0 0 34 51.5"><defs><radialGradient id="a" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".102"/><stop offset="1" stop-opacity="0"/></radialGradient><radialGradient id="b" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".2"/><stop offset=".483" stop-opacity=".039"/><stop offset="1" stop-opacity="0"/></radialGradient></defs><g transform="translate(-654 -1829.5)"><ellipse cx="17" cy="7" rx="17" ry="7" transform="translate(654 1867)" fill="url(#a)"/><ellipse cx="8" cy="3" rx="8" ry="3" transform="translate(663 1870.5)" fill="url(#b)"/></g><path class="marker" d="M33.5 16.5c0 7.511-10.055 20.883-14.463 26.4a2.6 2.6 0 0 1-4.073 0C10.555 37.383.5 24.011.5 16.5a16.5 16.5 0 0 1 33 0Z" fill="#1a1a1a"/><path class="icon" d="M23 11.5h-7.5v3H11v9h12v-12Zm-10.5 6.75H14v1.5h-1.5Zm6 .75H17v-1.5h1.5Zm1.5 0v-1.5h1.5V19Zm-6-3v1.5h-1.5V16Zm3-3h1.5v1.5H17Zm4.5 0v1.5H20V13ZM17 16.75v-1.5h1.5v1.5Zm4.5 0H20v-1.5h1.5Z" fill="#fff"/></svg>';

  document.querySelector('.section-contact').addEventListener('click', function (e) {
    if (e.target.classList.contains('js-contact-btn')) {
      // trigger de contact form modal on the dynamic map markers templates
      const trigger = e.target.dataset.trigger;
      document.querySelector(`.form-contact-page[data-contact="${trigger}"]`).click();
    }
  });

  jQuery('.js-map-holder:has(.js-map-canvas)')
    .each((i, section) => {
      getCsrf()
        .then(result => {
          let query = `
            query Addresses {
              entries(section: "addresses") {
                ... on address_Entry {
                  uid
                  title
                  function
                  addressCategories {
                    uid
                  }
                  address
                  country {
                    uid
                    title
                  }
                  responsibleForCountries {
                    uid
                    title
                  }
                  email
                  phone
                  mobile
                  fax
                  lat
                  lng
                  note
                }
              }
            }
          `;
          loadData(query, result.name, result.value, section.dataset.site ?? '')
            .then(data => {
              const markers = data.data.entries;
              renderMarkers(markers);
            });
        });
      const $section = jQuery(section);
      const $selectContinent = $section.find('#map-continent');
      const $selectCountry = $section.find('#map-country');
      const $selectGroup = $section.find('#map-contact-group');
      const $map = $section.find('.js-map-canvas');
      const $mainContactsContainer = document.getElementById('js-main-contacts');
      const $tmplMarker = $section.find('[data-tmpl-marker]').html();
      const $tmplMainContact = $section.find('[data-tmpl-main]').html();
      const geocoder = new Geocoder();
      const map = new Map($map[0], {
        zoom: 1,
        center: new LatLng(47.69562136671785, 13.959023130886662),
        restriction: {
          latLngBounds: {
            north: 85,
            south: -85,
            west: -180,
            east: 180
          },
          strictBounds: true
        },
        mapTypeControl: false,
        zoomControl: false,
        cameraControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        mapId: '8a0260423ca136aa', // https://console.cloud.google.com/google/maps-apis/studio/maps/8a0260423ca136aa?project=craft-1508938094732
      });

      if (navigator.geolocation) {
        // ask visitor for location and redraw the map on visitor location
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            map.setCenter(pos);
            geocoder.geocode( { 'location': pos}, function(results, status) {
              if (status === 'OK') {
                let country = Array.from(results).pop().formatted_address;
                updateCountrySelect(kebabCase(country));
              } else {
                console.log('Geocode was not successful for the following reason: ' + status);
              }
            });

          }
        );
      }

      let bounds = new google.maps.LatLngBounds();
      let boundsTimer = null;

      async function getCsrf() {
        const response = await fetch('/actions/frontend/site/get-csrf/', {
          method: 'POST'
        });
        return response.json();
      }

      async function loadData(query = '', csrfName, csrfValue, siteUrl = '') {
        const response = await fetch(`${siteUrl.replace(/\/$/, '')}/graphql/`, {
          method: 'POST',
          headers: {
            csrfName: csrfValue,
            'Content-Type': 'application/graphql',
          },
          body: query
        });
        return response.json();
      }

      function renderMarkers(data) {
        const parser = new DOMParser();
        const infoWindow = new InfoWindow();
        let availableGroups = [];

        const markers = data.map((markerData, i) => {
          // remove null values from graphQl
          Object.keys(markerData).forEach((k) => markerData[k] == null && delete markerData[k]);
          // skip address if it doesn't have lat and lng
          if (markerData.lat && markerData.lng) {

            const position = new LatLng(parseFloat(markerData.lat), parseFloat(markerData.lng));

            const marker = new AdvancedMarkerElement({
              position,
            });
            // flatten the country data in a new variable, original is needed for $tmplMainContact
            markerData.countries = [... new Set([...markerData.country.map((country) => {return country.uid;}), ...markerData.responsibleForCountries.map((country) => {return country.uid;})])];
            // only keep the lvl2 country for the $tmplMainContact
            markerData.country = markerData.country.map((country) => {return country.title;});
            markerData.country = Array.from(markerData.country).pop();
            // flatten the addressCategories data and collect all available options
            markerData.addressCategories = markerData.addressCategories.map((category) => {
              availableGroups.push(category.uid);
              return category.uid;
            });
            setMarkerContent(marker, markerData, suitecaseSvgString);

            bounds.extend(marker.position);

            marker.addListener('gmp-click', () => {
              const allMarkers = document.getElementsByClassName('map-marker');
              Array.from(allMarkers).forEach((marker) => marker.classList.remove('active'));
              marker.content.classList.add('active');
              infoWindow.close();
              infoWindow.setContent(tmpl($tmplMarker, { data: markerData }));
              infoWindow.open(marker.map, marker);
            });

            return marker;
          }
        }).filter(item => item !== undefined);

        infoWindow.addListener('closeclick', ()=>{
          const allMarkers = document.getElementsByClassName('map-marker');
          Array.from(allMarkers).forEach((marker) => marker.classList.remove('active'));
        })

        updateContactGroupsSelect(availableGroups);

        const cluster = new MarkerClusterer({
          map,
          markers,
          renderer: {
            render: ({ count, position }, stats) => {
              const clusterSvgString =
                '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="51.5" viewBox="0 0 34 51.5"><defs><radialGradient id="a" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".102"/><stop offset="1" stop-opacity="0"/></radialGradient><radialGradient id="b" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".2"/><stop offset=".483" stop-opacity=".039"/><stop offset="1" stop-opacity="0"/></radialGradient></defs><g transform="translate(-654 -1829.5)"><ellipse cx="17" cy="7" rx="17" ry="7" transform="translate(654 1867)" fill="url(#a)"/><ellipse cx="8" cy="3" rx="8" ry="3" transform="translate(663 1870.5)" fill="url(#b)"/></g><path d="M33.5 16.5c0 7.511-10.055 20.883-14.463 26.4a2.6 2.6 0 0 1-4.073 0C10.555 37.383.5 24.011.5 16.5a16.5 16.5 0 0 1 33 0Z" fill="#fff"/><text transform="translate(0 11)" fill="#333" font-size="16" font-family="myriad-pro, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Noto Sans, Liberation Sans, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji" font-weight="600">\n' +
                '    <tspan x="12.712" y="12">' + String(count) + '</tspan>\n' +
                '</text></svg>';
              const clusterSvg = parser.parseFromString(
                clusterSvgString,
                'image/svg+xml',
              ).documentElement;
              // create marker using svg icon
              return new AdvancedMarkerElement({
                position,
                content: clusterSvg,
              });
            }
          },
        });

        // initial filtering
        filterMarkers(markers, cluster);

        $selectContinent.on('change', filterCountrySelect);
        $selectContinent.removeAttr('disabled');
        $selectContinent.on('change', filterMarkers.bind(null, markers, cluster));
        $selectCountry.on('change', filterMarkers.bind(null, markers, cluster));
        $selectCountry[0].disabled = $selectContinent[0].selectedIndex === 0;
        $selectGroup.on('change', filterMarkers.bind(null, markers, cluster));
        $selectGroup.removeAttr('disabled');
      }

      function filterCountrySelect() {
        const options = $selectCountry[0].options;
        for (let option of options) {
          option.classList.add('d-none');
          if (option.dataset.parent === $selectContinent[0].value) {
            option.classList.remove('d-none');
          }
        }
        $selectCountry[0].selectedIndex = 0;
        $selectCountry[0].disabled = false;
      }

      function updateCountrySelect(country) {
        const options = $selectCountry[0].options;
        for (let option of options) {
          if (option.value === country) {
            $selectContinent.val(option.dataset.parent);
            $selectContinent.trigger('change');
            option.selected = true;
            $selectCountry.trigger('change');
            return;
          }
        }
      }

      function setMarkerContent(marker, dataset, svg) {
        const markerContent = document.createElement('div');
        markerContent.classList.add('map-marker');
        Object.assign(markerContent.dataset, dataset);
        markerContent.innerHTML = svg;
        marker.content = markerContent;
      }

      function filterMarkers(markers = [], cluster = {}) {
        const continent = $selectContinent[0].selectedOptions[0];
        const country = $selectCountry[0].selectedOptions[0];
        const continentValue = continent.value;
        const countryValue = country.value;
        const countrySorting = country.dataset.sort;
        let filteredMarkers = [];
        let mainContactsTmpl = [];
        let availableGroups = [];
        bounds = new google.maps.LatLngBounds();
        // reset the contact groups to the first option
        updateContactGroupsSelect(availableGroups, ((event?.target || '') === $selectCountry[0])||((event?.target || '') === $selectContinent[0]));
        const group = $selectGroup[0].selectedOptions[0];
        const groupValue = group.value;
        clearTimeout(boundsTimer);

        let mainContacts = JSON.parse(document.getElementById('main-contacts').dataset.contacts);
        if (countryValue) {
          mainContacts = JSON.parse(country.dataset.contacts);
        } else if (continentValue) {
          mainContacts = JSON.parse(continent.dataset.contacts);
        }

        filteredMarkers = markers.filter(marker => {
          let markerDataset = marker.content.dataset;
          const foundAsMain = markerDataset.uid in mainContacts;

          const latLng = markerDataset?.oldLatLng?.split(',').filter(Number);
          if (latLng !== undefined && latLng.length === 2) {
            // move the marker back to the original position if needed
            markerDataset.oldLatLng = null;
            marker.position = new LatLng(parseFloat(latLng[0]), parseFloat(latLng[1]));
          }
          if (foundAsMain) {
            // marker is the main contact for this country
            const mainLatLng = mainContacts[markerDataset.uid]?.split(',').filter(Number);
            if (mainLatLng.length === 2) {
              // move the marker position if needed
              markerDataset.oldLatLng = marker.position.lat + ',' + marker.position.lng;
              marker.position = new LatLng(parseFloat(mainLatLng[0]), parseFloat(mainLatLng[1]));
            }

            if (countryValue) {
              mainContactsTmpl.push(tmpl($tmplMainContact, { data: markerDataset }));
            }
          }
          setMarkerContent(marker, markerDataset, foundAsMain ? buildingSvgString : suitecaseSvgString);

          const foundContinent = markerDataset.countries.split(',').includes(countryValue || continent.value);
          const foundGroup = groupValue === '' || markerDataset.addressCategories.split(',').includes(groupValue);

          let found = (foundAsMain || foundContinent || continentValue === '');
          if (found) {
            markerDataset.addressCategories.split(',').map((category) => {
              availableGroups.push(category);
            });
          }

          found = found && foundGroup;
          if (found) {
            bounds.extend(marker.position);
          }

          return found;
        });

        // update clusters
        cluster.markers = filteredMarkers;
        cluster.render();

        if (bounds) {
          // initial map zoom is high to show the world but zooms incorrect in combination with bounds so reset first
          map.setZoom(7);
          map.fitBounds(bounds);

          google.maps.event.addListenerOnce(map, 'idle', function() {
            const width = window.innerWidth;
            if (width > 1024) {
              const x = width > 1920 ? 0 : (0.335 * width - 640);
              map.panBy(x, 0);
              map.setZoom(map.getZoom() - 1);
            }
          });

          if (filteredMarkers.length === 1) {
            map.setZoom(7);
          }
        }

        renderMainContacts(mainContactsTmpl);
        updateContactGroupsSelect(availableGroups, (event?.target || '') === $selectCountry[0]);
        updateContacts(continentValue, countryValue, countrySorting);
      }

      function updateContacts(continent, country, sorting) {
        // hide addresses unrelated to the continent and country
        const $addresses = document.querySelectorAll('#accordionContacts [data-country]');
        for (const address of $addresses) {
          address.classList.add('d-none');
          if (address.dataset.country.includes(continent) && address.dataset.country.includes(country)) {
            address.classList.remove('d-none');
          }
        }

        const $groups = document.querySelectorAll('#accordionContacts .accordion-item');
        for (const group of $groups) {
          // hide contact groups without related addresses
          const addressesHidden = group.querySelectorAll('.contact:not(.d-none)')
          group.classList.add('d-none');
          if (addressesHidden.length !== 0) {
            group.classList.remove('d-none');
          }

          // change the sorting of the addresses
          // let addressesAll = group.querySelectorAll('.contact')
          // if (sorting === "postalCode") {
          //   addressesAll = Array.from(addressesAll).sort(function(a, b) {
          //     return a.dataset.zip > b.dataset.zip ? 1 : -1;
          //   });
          // } else {
          //   addressesAll = Array.from(addressesAll).sort(function (a, b) {
          //     return a.dataset.title > b.dataset.title ? 1 : -1;
          //   });
          // }
          // group.querySelectorAll('.row.gy-7')[0].innerHTML = addressesAll.map(e => e.outerHTML).join("");
        }
      }

      function updateContactGroupsSelect(availableGroups, reset) {
        reset = reset || false;
        // filter duplicates
        availableGroups = Array.from(new Set(availableGroups));

        // show/hide available options
        const options = $selectGroup[0].options;
        for (const option of options) {
          option.classList.add('d-none');
          if (option.value === '' || availableGroups.includes(option.value)) {
            option.classList.remove('d-none');
          }
        }

        // reset to first option
        if (reset) {
          $selectGroup[0].selectedIndex = 0;
        }
      }

      function renderMainContacts(data = []) {
        $mainContactsContainer.innerHTML = data.join('');
      }
    });

}
